import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useDebounce} from '@/hooks/useDebounce';
import {log} from '@/helpers/logger';

export async function ensureLatestDeployment() {
  if (import.meta.env.DEV) {
    // This is not needed for dev because hot-reload serves the same purpose,
    // also cache.json is only created at the build time thus not available in dev
    return;
  }

  return fetch('/cache.json')
    .then((response) => response.json().catch(() => {
      log('warn', 'Cache file not found, reloading will not be possible');
    }))
    .then((cache?: { hash: string }) => {
      const hash = cache?.hash ?? 'unknown';

      if (localStorage.getItem('hash') !== hash) {
        localStorage.setItem('hash', hash);

        log('info', 'Cache will be reloaded, application files are stale');
        // @ts-expect-error - Firefox needs argument to force cache reload
        window.location.reload(true);
      }
    })
    .catch(() => {
      log('warn', 'Cache reload did not work, application may appear stale');
    });
}

export default function useLatestDeployment() {
  const location = useLocation();
  const debouncedLocation = useDebounce(location);

  useEffect(() => {
    void ensureLatestDeployment();
  }, [debouncedLocation]);
}
